import React from "react";
import Formfooter from "../Components/login/FormFooter";
import Formnav from "../Components/login/FormNav";
import Loginform from "../Components/login/LoginForm";
import SingleSignOnLogin from "../Components/login/SingleSignonLogin";

function Login() {
  // localStorage.clear("");
  return (
    <>
      {/* <SingleSignOnLogin/> */}

      <title>Log In - Bajaj Finserv</title>
      <div className="login-page">
        {/* <div className="login-content h-100"> */}
        {/* <div className="container h-100"> */}
        {/* <div className="row h-100"> */}
        {/* <div className="ipad-bottom m-auto"> */}
        {/* <Loginform />
                <Formfooter /> */}
        <SingleSignOnLogin />
        <Formfooter />
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
      </div>
    </>
  );
}

export default Login;
